import { useEffect, useState } from 'react';
import { useWhitelabel } from './useWhitelabel';

export const useFavicon = () => {
  const { whitelabelImagePaths } = useWhitelabel();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Function to set the favicon dynamically
    const setFavicon = (iconPath: string) => {
      // Explicitly cast the element to HTMLLinkElement
      const link = (document.querySelector("link[rel='icon']") ||
        document.createElement('link')) as HTMLLinkElement;
      link.type = 'image/png';
      link.rel = 'icon';
      link.href = iconPath;
      document.head.appendChild(link); // Add or update the favicon in <head>
    };

    // Dynamically set the favicon
    setFavicon(whitelabelImagePaths.faviconPath);
    setIsLoading(false);
  }, [whitelabelImagePaths.faviconPath]);

  return { isLoading };
};
